import {
  Grid,
  Card,
  CardContent,
  Switch,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
} from "../../../../components";
import "../../configuracoes.style.css";

const ConfiguracaoCadastroTab = ({
  configuracao,
  onChangeSwitch,
  onChange,
}) => {
  return (
    <Card className="p-2">
      <CardContent>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            CAD001 - Em pessoas, campo CPF/CNPJ é obrigatório.
          </Grid>
          <Grid item xs={4}>
            <Switch
              id="obrigatoriedadeCnpjCpf"
              name="obrigatoriedadeCnpjCpf"
              checked={configuracao?.obrigatoriedadeCnpjCpf || false}
              onChange={onChangeSwitch}
              color="primary"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            CAD002 - Modalidade de Cálculo Padrão de Precificação de Produtos.
          </Grid>
          <Grid item xs={4}>
            <Select
              label="Tipo de margem"
              id="margemCalculo"
              name="margemCalculo"
              margin="normal"
              value={configuracao.margemCalculo}
              required
              onChange={onChange}
            >
              <MenuItem value={"INVERSA"}>Margem Inversa</MenuItem>
              <MenuItem value={"CONVENCIONAL"}>Margem Convencional</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            CAD003 - E-mail personalizado para envio de documentos
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="emailPersonalizado"
              name="emailPersonalizado"
              label="E-mail personalizado"
              value={configuracao?.emailPersonalizado || ""}
              onChange={onChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">@adsoft.com.br</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default ConfiguracaoCadastroTab;
